// @flow

import * as React from 'react';
import styled from 'styled-components';
import ReactSVG from 'react-svg';
import CheckIcon from './check.svg';
import UncheckIcon from './uncheck.svg';
import CheckLightIcon from './check_light.svg';

const StyledWrapper = styled.div`
  text-decoration: none;
  user-select: none;
  text-decoration: none;
  letter-spacing: .5px;
  border: none;
  border-radius: 2px;
  align-items: center;
  justify-content: center;
  display: flex;
  margin-top: 3px;
  
  :hover{
    cursor: pointer;
  }
`;

const StyledLabel = styled.div`
  height: 100%;
  margin-left: 5px;
`;

const StyledCheckbox = (props: any): React.Node => (
    <StyledWrapper {...props} >
        <ReactSVG
            path={props.checked ?
                props.isLightTheme ?
                    CheckLightIcon :
                    CheckIcon :
                UncheckIcon}
            style={{
                fill: props.fill ? props.fill : '#215597',
                width: props.width ? props.width : '20px',
                height: props.height ? props.height : '20px',
                display: 'flex',
                alignItems: 'center',
            }}
        />
        {props.label && <StyledLabel>{props.label}</StyledLabel>}
    </StyledWrapper>
);

export default StyledCheckbox;


// WEBPACK FOOTER //
// ./src/components/checkbox/Checkbox.jsx